import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation, useQueryClient } from 'react-query';
import { CardHeader, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
//Import Flatepicker
import 'flatpickr/dist/themes/material_blue.css';
import Flatpickr from 'react-flatpickr';

import {
  addNewClaim as onAddNewClaim,
  updateClaim as onUpdateClaim,
  setClaimSummary,
} from 'store/actions';

import { PaymentStatus } from './ClaimCol';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import ClaimsModal from './ClaimModal';

import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from 'reactstrap';
import moment from 'moment';
import { useAuth } from 'hooks/useAuth';
import { getSearchColumns, sumArray } from 'utils/tools';
import { ToastContainer } from 'react-toastify';
import {
  getAllClaimApi,
  getAssignedClaimsByAreaIdApi,
  getAllAssignedClaimsByAreaIdApi,
} from 'api/claim';
import { getClaimStatusCountsApi } from 'api/report';
import { useRole } from 'hooks/useRole';
import MainFilter from 'components/Common/MainFilter';
import StatCards from 'components/Common/StatCards';
import 'components/Common/tabs.scss';

function AllClaims() {
  const [activeTab, setActiveTab] = useState(1);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();
  const [pages, setPages] = useState(0);
  const queryClient = useQueryClient();
  const {
    isFacilitator,
    isSiteCord,
    isCountyCoordinator,
    isRegionalCountyCoordinator,
    isClusterLeader,
    isFinance,
    isDirector,
    isAdmin,
    isSuperAdmin,
    isData,
    addresses,
  } = useRole();
  const { roleId } = useAuth();
  const { wardId, constituencyId, countyId, regionId } = isAuthenticated
    ? addresses[0]
    : {};

  const { claimSummary } = useSelector((state) => ({
    claimSummary: state.reports.claims,
  }));

  const claimsCardData = [
    {
      title: 'Total Claims',
      iconClass: 'bx bx-user',
      description: claimSummary?.length
        ? sumArray(claimSummary, 'totalClaims')
        : 0,
    },
    {
      title: 'Approved',
      iconClass: 'bx bx-check-circle',
      description: claimSummary?.length
        ? sumArray(claimSummary, 'totalProcessed')
        : 0,
    },
    {
      title: 'Processing',
      iconClass: 'bx bx-pause-circle',
      description: claimSummary?.length
        ? sumArray(claimSummary, 'totalPending')
        : 0,
    },
    {
      title: 'Rejected',
      iconClass: 'bx bx-error-circle',
      description: claimSummary?.length
        ? sumArray(claimSummary, 'totalDeclined')
        : 0,
    },
  ];
  const dateFormat = 'DD-MM-YYYY';
  const [pagination, setPagination] = useState({
    pageSize: 10,
    pageNumber: 1,
    sortBy: 'id',
    ascendingSort: false,
    wardIds: getSearchColumns()?.find((t) => t?.name === 'wardIds')?.value,
    searchColumns: [
      ...(isFacilitator
        ? [
          {
            name: 'wardId',
            value: wardId,
          },
        ]
        : []),
      ...(isCountyCoordinator
        ? [
          {
            name: 'countyId',
            value: countyId,
          },
          {
            name: 'countyIds',
            values: addresses?.map((c) => c.countyId),
          },
        ]
        : []),
      ...(isRegionalCountyCoordinator
        ? [
          {
            name: 'regionIds',
            values: addresses?.map((c) => c.regionId),
          },
        ]
        : []),
      ...(isClusterLeader
        ? [
          {
            name: 'constituencyIds',
            values: addresses?.map((c) => c.constituencyId),
          },
        ]
        : []),
      ...(isSiteCord
        ? [
          {
            name: 'constituencyId',
            value: constituencyId,
          },
          {
            name: 'constituencyIds',
            values: addresses?.map((c) => c.constituencyId),
          },
        ]
        : []),
      {
        name: 'endDate',
        value: moment().format(dateFormat),
      },
      {
        name: 'startDate',
        value: moment().subtract(90, 'days').format(dateFormat),
        // value: moment().startOf('year').format(dateFormat),
      },
    ],
  });

  //meta title
  document.title = 'Claims | SUN Welfare Administration System';

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [member, setClaim] = useState(null);

  const { mutate: mutateClaimCounts, data } = useMutation(
    (payload) => getClaimStatusCountsApi(payload),
    {
      onSuccess: (res) => {
        dispatch(setClaimSummary(res?.data));
      },
      onSettled: () => {
        queryClient.invalidateQueries('get-all-counties');
      },
    },
  );

  const {
    mutate: mutateAssignedClaims,
    isLoading: isLoadingAssignedClaims,
    data: assignedClaimsData,
  } = useMutation(
    async (payload) => {
      console.log(payload);
      const { searchColumns } = payload;
      const wardId = searchColumns?.find(s => s.name === 'wardIds')?.values;
      const countyId = searchColumns?.find(s => s.name === 'countyIds')?.values;
      const regionId = searchColumns.find(s => s.name === 'regionIds')?.values;
      const constituencyId = searchColumns.find(s => s.name === 'constituencyIds')?.values;
      let areaParams = {};
      if (isFacilitator || wardId) {
        areaParams = { ...areaParams, wardId: wardId || pagination.wardIds, filter: true };
      }
      if (isSiteCord || isClusterLeader || constituencyId) {
        areaParams = { ...areaParams, subCountyId: constituencyId, filter: true };
      }
      if (isCountyCoordinator || countyId) {
        areaParams = { ...areaParams, countyId, filter: true };
      }

      if (isRegionalCountyCoordinator || regionId) {
        areaParams = { ...areaParams, regionId, filter: true };
      }

      if (
        (isClusterLeader ||
          isFacilitator ||
          isCountyCoordinator ||
          isSiteCord) &&
        Object.keys(areaParams).length === 0
      ) {
        throw new Error('Invalid area parameters: No valid area ID found.');
      }
      const idNumber = pagination.searchColumns.find(
        (t) => t.name === 'idNumber',
      );

      if (idNumber?.value) {
        areaParams.idNumber = idNumber.value;
        areaParams.startDate = null;
        areaParams.endDate = null;
      } else {
        areaParams.startDate = pagination.searchColumns?.find(
          (c) => c.name === 'startDate',
        )?.value;
        areaParams.endDate = pagination.searchColumns?.find(
          (c) => c.name === 'endDate',
        )?.value;
      }

      const burialPermitSerialNumber = pagination.searchColumns.find(
        (t) => t.name === 'burialPermitSerialNumber',
      );

      if (burialPermitSerialNumber?.value) {
        areaParams.burialPermitSerialNumber = burialPermitSerialNumber.value;
      }

      const memberId = pagination.searchColumns.find(
        (t) => t.name === 'memberId',
      );
      if (memberId?.value) {
        areaParams.memberId = memberId.value;
      }

      areaParams.pageNumber = payload?.pageNumber || 0;
      areaParams.pageSize = payload?.pageSize || 50;
      return getAssignedClaimsByAreaIdApi(areaParams);
    },
    {
      onSuccess: (res) => {
        res.pages > 0 && setPages(res?.pages);
      },
      onSettled: () => {
        queryClient.invalidateQueries('get-all-counties');
      },
    },
  );

  const {
    mutate: mutateAllAssignedClaims,
    isLoading: isLoadingAllAssignedClaims,
    data: allAssignedClaimsData,
  } = useMutation(
    async (payload) => {
      let areaParams = {};
      if (isFacilitator && wardId) {
        areaParams = { wardId };
      } else if (isSiteCord && constituencyId) {
        areaParams = { subCountyId: constituencyId };
      } else if (isCountyCoordinator && countyId) {
        areaParams = { countyId };
      } else if (isClusterLeader && countyId) {
        areaParams = { countyId };
      } else if (isRegionalCountyCoordinator && regionId) {
        areaParams = { regionId };
      }

      if (
        (isClusterLeader ||
          isFacilitator ||
          isCountyCoordinator ||
          isSiteCord) &&
        Object.keys(areaParams).length === 0
      ) {
        throw new Error('Invalid area parameters: No valid area ID found.');
      }

      const idNumber = pagination.searchColumns.find(
        (t) => t.name === 'idNumber',
      );
      if (idNumber?.value) {
        areaParams.idNumber = idNumber.value;
        areaParams.startDate = null;
        areaParams.endDate = null;
      } else {
        areaParams.startDate = pagination.searchColumns?.find(
          (c) => c.name === 'startDate',
        )?.value;
        areaParams.endDate = pagination.searchColumns?.find(
          (c) => c.name === 'endDate',
        )?.value;
      }

      const memberId = pagination.searchColumns.find(
        (t) => t.name === 'memberId',
      );
      if (memberId?.value) {
        areaParams.memberId = memberId.value;
      }

      const burialPermitSerialNumber = pagination.searchColumns.find(
        (t) => t.name === 'burialPermitSerialNumber',
      );

      if (burialPermitSerialNumber?.value) {
        areaParams.burialPermitSerialNumber = burialPermitSerialNumber.value;
      }

      areaParams.pageNumber = payload?.pageNumber || 0;
      areaParams.pageSize = payload?.pageSize || 50;
      // areaParams.startDate = pagination.searchColumns?.find(
      //   (c) => c.name === 'startDate',
      // )?.value;
      // areaParams.endDate = pagination.searchColumns?.find(
      //   (c) => c.name === 'endDate',
      // )?.value;

      return getAllAssignedClaimsByAreaIdApi(areaParams);
    },
    {
      onSuccess: (res) => {
        res.pages > 0 && setPages(res?.pages);
      },
      onSettled: () => {
        queryClient.invalidateQueries('get-all-counties');
      },
    },
  );

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      fullNames: (member && member.fullNames) || '',
      reportedDate: (member && member.reportedDate) || '',
      groupName: (member && member.groupName) || '',
      deceasedName: (member && member.deceasedName) || '',
      status: (member && member.status) || 'Paid',
      badgeclass: (member && member.badgeclass) || 'success',
      memberStatus: (member && member.memberStatus) || 'Mastercard',
    },
    validationSchema: Yup.object({
      fullNames: Yup.string()
        .matches(/[0-9\.\-\s+\/()]+/, 'Please Enter Valid Claim Id')
        .required('Please Enter Your Claim Id'),
      reportedDate: Yup.string().required('Please Enter Your Billing Name'),
      groupName: Yup.string().required('Please Enter Your Claim Date'),
      deceasedName: Yup.string()
        .matches(/[0-9\.\-\s+\/()]+/, 'Please Enter Valid Amount')
        .required('Total Amount'),
      status: Yup.string().required('Please Enter Your Payment Status'),
      badgeclass: Yup.string().required('Please Enter Your Badge Class'),
      memberStatus: Yup.string().required('Please Enter Your Payment Method'),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateClaim = {
          id: member ? member.id : 0,
          fullNames: values.fullNames,
          reportedDate: values.reportedDate,
          groupName: values.groupName,
          deceasedName: values.deceasedName,
          status: values.status,
          memberStatus: values.memberStatus,
          badgeclass: values.badgeclass,
        };
        // update member
        dispatch(onUpdateClaim(updateClaim));
        validation.resetForm();
      } else {
        const newClaim = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          fullNames: values['fullNames'],
          reportedDate: values['reportedDate'],
          groupName: values['groupName'],
          deceasedName: values['deceasedName'],
          status: values['status'],
          memberStatus: values['memberStatus'],
          badgeclass: values['badgeclass'],
        };
        // save new member
        dispatch(onAddNewClaim(newClaim));
        validation.resetForm();
      }
      toggle();
    },
  });

  const toggleViewModal = () => setModal1(!modal1);

  const selectClaimState = (state) => state.members;
  const ClaimProperties = createSelector(selectClaimState, (Claim) => ({
    members: generateFakeData(),
    // TO-DO return this for live data
    // members: Claim.members,
    loading: Claim.loading,
  }));

  useEffect(() => {
    mutateClaimCounts({
      fromDate: pagination.searchColumns?.find((r) => r.name === 'startDate')
        ?.value,
      toDate: moment().format('DD-MM-YYYY'),
      wardIds: pagination.wardIds,
      countyIds: pagination.searchColumns.find((s) => s.name === 'countyIds')
        ?.values,
      regionIds: pagination.searchColumns.find((s) => s.name === 'regionIds')
        ?.values,
      constituencyIds: pagination.searchColumns.find(
        (s) => s.name === 'constituencyIds',
      )?.values,
      address: {},
    });
    console.log('Pagination Change', pagination)
    if (activeTab === 1) {
      // Fetch assigned claims
      mutateAssignedClaims({
        ...pagination,
        pageNumber: pagination.pageNumber - 1,
      });
    } else {
      // Fetch all claims
      mutateAllAssignedClaims({
        ...pagination,
        pageNumber: pagination.pageNumber - 1,
      });
    }
  }, [activeTab, pagination]);

  const onChangePagination = ({ page, limit }, filters, sorter) => {
    let searchColumns = [...pagination.searchColumns];

    const filterKeys = [
      "id",
      "firstName",
      "lastName",
      "email",
      "claimNumber",
      "idNumber",
      "burialPermitSerialNumber",
      "memberId",
      "mobileNumber1",
    ];

    filterKeys.forEach((key) => {
      if (filters?.[key]) {
        // remove existing filter for this column
        searchColumns = searchColumns.filter((c) => c.name !== key);

        // add new filter
        searchColumns.push({
          name: key,
          value: filters[key],
        });
      }
    });
    setPagination({
      ...pagination,
      pageNumber: page || pagination.pageNumber,
      pageSize: limit || pagination.pageSize,
      searchColumns,
    });
  };

  const toggle = () => {
    if (modal) {
      setModal(false);
      setClaim(null);
    } else {
      setModal(true);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div className="form-check font-size-16">
            <input className="form-check-input" type="checkbox" id="checkAll" />
            <label className="form-check-label" htmlFor="checkAll"></label>
          </div>
        ),
        accessor: '#',
        width: '20px',
        filterable: true,
        Cell: (cellProps) => (
          <div className="form-check font-size-16">
            <input className="form-check-input" type="checkbox" id="checkAll" />
            <label className="form-check-label" htmlFor="checkAll"></label>
          </div>
        ),
      },
      {
        Header: 'ID',
        accessor: 'id',
        filterable: true,
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
      {
        Header: 'PRINCIPAL MEMBER',
        accessor: (row) =>
          `${row?.member?.firstName || ''} ${row?.member?.lastName || ''}`,
        filterable: true,
        Cell: (cellProps) => {
          return <span>{cellProps?.value}</span>;
        },
      },
      {
        Header: 'DATE OF DEATH',
        accessor: 'deathCertificate.deathDate',
        filterable: true,
        Cell: (cellProps) => {
          return <span>{moment(cellProps.value).format('DD MMM YYYY')}</span>;
        },
      },
      {
        Header: 'REPORTED DATE',
        accessor: 'reportedDateTime',
        filterable: true,
        Cell: (cellProps) => {
          return (
            <span>{moment(cellProps.value).format('DD MMM YYYY h:mm A')}</span>
          );
        },
      },
      {
        Header: 'Claim Number',
        accessor: 'claimNumber',
        filterable: true,
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
      {
        Header: 'Claim Amount',
        accessor: 'claimAmount',
        filterable: true,
        Cell: ({ value }) => {
          return <span>{value ? Number(value).toLocaleString() : '0'}</span>;
        },
      },
      {
        Header: 'DECEASED NAME',
        accessor: (row) =>
          `${row.deathCertificate?.firstName || ''} ${row.deathCertificate?.lastName || ''
          }`,
        filterable: true,
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
      {
        Header: 'DECEASED AGE',
        accessor: 'deathCertificate.age',
        filterable: true,
        Cell: ({ value }) => {
          return (
            <span>
              {value !== undefined && value !== null
                ? Math.round(value)
                : 'N/A'}
            </span>
          );
        },
      },
      {
        Header: 'LOCATION',
        filterable: true,
        accessor: (row) =>
          `${row.ward + ',' + row.subCounty + ',' + row.county}`,
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
      {
        Header: 'APPROVAL STATUS',
        // accessor: 'claimStatus.status',
        accessor: (row) =>
          `${row.claimStatus?.status === 'Revise' &&
            row.claimStatus?.destinationRoleId == roleId
            ? 'Revise'
            : row.claimStatus?.status
          }`,
        Cell: (cellProps) => {
          return <PaymentStatus {...cellProps} />;
        },
      },
      {
        Header: 'APPROVED BY',
        accessor: 'claimStatus.approvedByName',
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
      {
        Header: 'CURRENT AT',
        accessor: 'claimStatus.sentToName',
        Cell: (cellProps) => {
          return <span>{cellProps.value}</span>;
        },
      },
    ],
    [],
  );

  const onSearch = (data) => {
    console.log(data);
    const searchColumns = [];
    let wardIds = pagination.wardIds;
    let countyIds = pagination.searchColumns.find(
      (s) => s.name === 'countyIds',
    )?.values;
    let regionIds = pagination.searchColumns.find(
      (s) => s.name === 'regionIds',
    )?.values;
    let constituencyIds = pagination.searchColumns.find(
      (s) => s.name === 'constituencyIds',
    )?.values;
    if (!isEmpty(data)) {
      if (data?.wardId?.value) {
        wardIds = [data?.wardId.value];
        searchColumns.push({ name: 'wardIds', values: wardIds });
      }
      if (data?.countyId?.value) {
        countyIds = [data?.countyId.value];
        searchColumns.push({ name: 'countyIds', values: countyIds });
      }
      if (data?.regionId?.value) {
        regionIds = [data?.regionId.value];
        searchColumns.push({ name: 'regionIds', values: regionIds });
      }
      if (data?.constituencyId?.value) {
        constituencyIds = [data?.constituencyId.value];
        searchColumns.push({
          name: 'constituencyIds',
          values: constituencyIds,
        });
      }
      data.startDate && searchColumns.push(data.startDate);
      data.endDate && searchColumns.push(data.endDate);
    }

    console.log(pagination, searchColumns);
    setPagination({ ...pagination, searchColumns });
    // let add = {};
    // searchColumns.forEach((a, i) => {
    //   add[a.name] = a.value;
    // });
    // setAddressData(add);
  };

  const handleClaimEdit = (claim) => {
    console.log(claim);
    // setClaim(claim);
    // setIsEdit(true);
    // toggle();
  };

  return (
    <React.Fragment>
      <ClaimsModal isOpen={modal1} toggle={toggleViewModal} />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Claims" />
          <StatCards items={claimsCardData} md="3" />
          <Card>
            <CardBody className="pb-0">
              <MainFilter
                inlineActions
                hasExport={isSuperAdmin || isFinance}
                pagination={pagination}
                resource={'claim'}
                onSearch={onSearch}
                showDateFilter
              />
            </CardBody>
          </Card>

          <Card>
            <CardHeader className="bg-transparent border-0 px-3 pt-3 pb-0">
            <Nav className="folder-tabs">
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 1 })}
                  onClick={() => setActiveTab(1)}
                >
                  <i className="mdi mdi-account-check-outline me-1" />
                  Assigned to me
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 2 })}
                  onClick={() => setActiveTab(2)}
                >
                  <i className="mdi mdi-file-document-multiple-outline me-1" />
                  All claims
                </NavLink>
              </NavItem>
            </Nav>
            </CardHeader>
            <CardBody>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={1}>
                        <TableContainer
                          pageSizeAtBottom
                          columns={columns}
                          data={assignedClaimsData?.list || []}
                          isGlobalFilter={true}
                          isAddOptions={true}
                          hasCreate={isFacilitator || isSuperAdmin || isAdmin}
                          isPagination={true}
                          filterable={false}
                          iscustomPageSizeOptions={true}
                          hasSearch
                          pages={pages}
                          showView
                          loading={isLoadingAssignedClaims}
                          showClaimEdit={isFacilitator || isSuperAdmin}
                          resource="claim"
                          addText="Create New Claim"
                          tableClass="align-middle table-nowrap table-check"
                          theadClass="table-light"
                          pagination="pagination pagination-rounded justify-content-end mb-2"
                          paginationData={pagination}
                          onChangePagination={onChangePagination}
                          searchByNames={[
                            {
                              value: 'claimNumber',
                              text: t('claims.claimNumber'),
                            },
                            { value: 'email', text: t('common.email') },
                            { value: 'idNumber', text: t('common.idNumber') },
                            { value: 'firstName', text: t('users.firstName') },
                            { value: 'lastName', text: t('users.lastName') },
                            {
                              value: 'mobileNumber1',
                              text: t('common.mobileNumber'),
                            },
                            {
                              value: 'burialPermitSerialNumber',
                              text: t('common.burialPermitSerialNumber'),
                            },
                          ]}
                        />
              </TabPane>
              <TabPane tabId={2}>
                        <TableContainer
                          columns={columns}
                          data={allAssignedClaimsData?.list?.reverse() || []}
                          isGlobalFilter={true}
                          isAddOptions={true}
                          hasCreate={isFacilitator}
                          isPagination={true}
                          filterable={false}
                          iscustomPageSizeOptions={true}
                          hasSearch
                          pages={pages}
                          // showClaimEdit={isFacilitator}
                          showView
                          loading={isLoadingAllAssignedClaims}
                          resource="claim"
                          addText="Create New Claim"
                          tableClass="align-middle table-nowrap table-check"
                          theadClass="table-light"
                          pagination="pagination pagination-rounded justify-content-end mb-2"
                          paginationData={pagination}
                          onChangePagination={onChangePagination}
                          searchByNames={[
                            {
                              value: 'claimNumber',
                              text: t('claims.claimNumber'),
                            },
                            { value: 'email', text: t('common.email') },
                            { value: 'idNumber', text: t('common.idNumber') },
                            { value: 'firstName', text: t('users.firstName') },
                            { value: 'lastName', text: t('users.lastName') },
                            {
                              value: 'mobileNumber1',
                              text: t('common.mobileNumber'),
                            },
                          ]}
                        />
              </TabPane>
            </TabContent>
            </CardBody>
          </Card>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}
AllClaims.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default AllClaims;
